import { Component, Input, OnInit } from '@angular/core';

// <section class="onboarding-hdr-wrapper">
// <section>
//   <onboarding-hdr 
//     [title]="'Instrument Alias'"
//     [info]="'123456 Roche Cobas Integra'"
//     [bgColor]="'light'"
//     [src]="'assets/images/bds/brIcons/icn_setup_instruments.svg'"
//     [height]="40"></onboarding-hdr>
// </section>
// </section>

// bgColors: orange; green; light


@Component({
  selector: 'onboarding-hdr',
  templateUrl: './onboarding-hdr.component.html',
  styleUrls: ['./onboarding-hdr.component.scss']
})
export class OnboardingHdrComponent implements OnInit {

  color: string;
  hasInfo: boolean = false;

  @Input() title: string = '';
  @Input() info: string = '';
  @Input() set bgColor(color: string) {
    this.mapColor(color);
  }
  @Input() src: string;
  @Input() height: number = 100;

  ngOnInit() {

  }


  mapColor(color: string) {

    if (this.info !== '') {
      this.hasInfo = true;
    }

    switch (color) {
      case 'orange':
        this.color = '#f69b44';
        break;
      case 'blue':
        this.color = '#a4b9d2';
        break;
      case 'light':
        this.color = '#478F8B';
        break;
    }
  }
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/onboarding-hdr/onboarding-hdr.component.ts